import Axios from 'axios'
import {getCookie, graphQLURL, graphQLToken} from '../../utils/common';
export const fetchCoachingDetails = (clientid) => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
      query {
        coachingclients(where:{
          clientid: "${clientid}"
        })  {
          id
          coachings {
            notes
            status
            createdAt
            updatedAt
            hoursUsed
            id
            recordingAssets {
              videourl
              recordingStart
              recordingEnd
              description
              name
              status
            }
          }
        }
      }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}

export const fetchRecordings = (coachingId) => {
  const apiUrl = getCookie('graphQLURL') || graphQLURL
  const token = getCookie('securityToken') || graphQLToken
  const query = {
    query: `
      query {
          coaching(where: {
            id: "${coachingId}"
          }) {
            notes
            status
            createdAt
            updatedAt
            hoursUsed
            id
            recordingAssets {
              videourl
              recordingStart
              recordingEnd
              description
              name
              status
            }
          }
      }`
  }
  
  const CONTENT_TYPE = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
  return Axios.post(apiUrl, query, CONTENT_TYPE)
}


// WEBPACK FOOTER //
// ./src/actions/coaching/index.js